import { ButtonProps } from '@chakra-ui/react';
import Button from '~/components/Button';

export const ModalClearFiltersButton: React.FC<ButtonProps> = (props) => (
  <Button
    _hover={{
      color: 'secondary.700',
      textDecoration: 'none',
    }}
    color="secondary.500"
    fontSize="md"
    fontWeight="normal"
    letterSpacing={0}
    textTransform="none"
    variant="link"
    {...props}
  >
    Clear All
  </Button>
);
